import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import { apiFetch } from '../api/client';
import { carUrl } from '../lib/slugId';
import { PageHeader } from '../components/PageHeader';
import type { Car, Paginated } from '../api/types';
import { CarCardMedia } from '../components/CarCardMedia';

export function Explore() {
  const { t } = useTranslation();
  const [cars, setCars] = useState<Car[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch<Paginated<Car>>('/api/v1/cars?filter[is_public]=1&include=user&per_page=24')
      .then((res) => setCars(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
      <PageHeader />
      <Stack spacing={3}>
      <Typography variant="h4">{t('explore.title')}</Typography>
      <Grid container spacing={3}>
        {cars.map((car) => (
          <Grid key={car.id} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card>
              <CardActionArea component={RouterLink} to={carUrl(car)}>
                <CarCardMedia car={car} height={200} />
                <CardContent>
                  <Typography variant="h6">{car.display_name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {car.year} {car.make} {car.model}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {car.intro}
                  </Typography>
                  {car.user && (
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                      {t('common.by')} {car.user.name}
                    </Typography>
                  )}
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      </Stack>
    </Container>
  );
}
